// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"checkbox_checkbox__w2SDD","label":"checkbox_label__Y21W1","text":"checkbox_text__oTRyl"};